/**
 * Gender
 */
export const GENDER = {
  female: 'female',
  male: 'male',
  doesntMatter: 'doesnt_matter',
};

const GENDER_LABEL = {
  [GENDER.female]: 'Female',
  [GENDER.male]: 'Male',
  [GENDER.doesntMatter]: "Doesn't matter",
};

export const getGenderLabel = (tone) => GENDER_LABEL[tone] || '';

/**
 * Gender tone
 */
export const GENDER_TONE = {
  feminine: 'feminine',
  neutral: 'neutral',
  masculine: 'masculine',
};

const DEFAULT_GENDER_TONE = GENDER_TONE.neutral;
export function isDefaultGenderTone(tone) {
  return tone === DEFAULT_GENDER_TONE;
}

export const getHistogramCategoryValue = (data, categoryName) => {
  const category = data ? data.find((entry) => entry.name === categoryName) : null;
  return (category && category.value) || 0;
};

const GENDER_MINIMAL_DIFF = 10;
export const getGenderHistogramTone = (data) => {
  const femaleValue = getHistogramCategoryValue(data, GENDER.female);
  const maleValue = getHistogramCategoryValue(data, GENDER.male);

  const isMinimalDiff = Math.abs(femaleValue - maleValue) < GENDER_MINIMAL_DIFF;
  if (isMinimalDiff) {
    return GENDER_TONE.neutral;
  }
  return femaleValue > maleValue ? GENDER_TONE.feminine : GENDER_TONE.masculine;
};

/**
 * Age groups
 */
export const AGE_GROUPS = [
  {
    localValue: 0,
    bucketEnd: 13,
    bucketStart: 13,
    label: '13',
  },
  {
    localValue: 1,
    bucketEnd: 24,
    bucketStart: 25,
    label: '25',
  },
  {
    localValue: 2,
    bucketEnd: 44,
    bucketStart: 45,
    label: '45',
  },
  {
    localValue: 3,
    bucketEnd: 65,
    bucketStart: 65,
    label: '65+',
  },
];

export const MIN_AGE_GROUP = AGE_GROUPS[0];
export const MAX_AGE_GROUP = AGE_GROUPS[AGE_GROUPS.length - 1];

export const getAgeGroupLabel = (value) => {
  const ageGroup = AGE_GROUPS.find((a) => a.bucketEnd === value);
  return ageGroup ? ageGroup.label : value;
};

export const AGE_GROUP_APPEAL = {
  youngest: 'youngest',
  younger: 'younger',
  oldest: 'oldest',
  older: 'older',
  middle: 'middle',
  neutral: 'neutral',
  none: 'none',
};

const AGE_MINIMAL_DIFF = 10;
const calcAgeAverage = (data) => {
  const sum = (data || []).reduce((acc, entry) => acc + (entry.value || 0), 0);
  return sum / (data.length || 1);
};
export const getAgeHistogramAppeal = (data) => {
  const average = calcAgeAverage(data);
  const youngestAverage = calcAgeAverage(data.slice(0, 3));
  const oldestAverage = calcAgeAverage(data.slice(-3));
  const middleAverage = calcAgeAverage(data.slice(2, 5));

  if (youngestAverage - average > AGE_MINIMAL_DIFF) {
    return AGE_GROUP_APPEAL.youngest;
  }
  if (middleAverage - average > AGE_MINIMAL_DIFF) {
    return AGE_GROUP_APPEAL.middle;
  }
  if (oldestAverage - average > AGE_MINIMAL_DIFF) {
    return AGE_GROUP_APPEAL.oldest;
  }
  return AGE_GROUP_APPEAL.neutral;
};
